export default __webpack_public_path__ + "static/media/success.76d6fcd8.gif";